<aura-edit-wrapper
  [(isEditing)]="isEditing"
  [isAllowedToEdit]="isAllowedToEdit()"
  (saved)="emailSaved.emit($event)"
  [showDivider]="true"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing() && isAllowedToEdit()) {
    <aura-contact-infos-email-form
      [dto]="currentEmail()"
      [requiredFields]="['email']"
      [allReadonly]="!editWrapper.isEditing()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <aura-contact-infos-email-display [currentContactInfos]="currentEmail()" />
  }
</aura-edit-wrapper>
